import { render, staticRenderFns } from "./WorkspaceProvenanceExplorerModal.vue?vue&type=template&id=7959200b&scoped=true"
import script from "./WorkspaceProvenanceExplorerModal.vue?vue&type=script&lang=js"
export * from "./WorkspaceProvenanceExplorerModal.vue?vue&type=script&lang=js"
import style0 from "./WorkspaceProvenanceExplorerModal.vue?vue&type=style&index=0&id=7959200b&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7959200b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7959200b')) {
      api.createRecord('7959200b', component.options)
    } else {
      api.reload('7959200b', component.options)
    }
    module.hot.accept("./WorkspaceProvenanceExplorerModal.vue?vue&type=template&id=7959200b&scoped=true", function () {
      api.rerender('7959200b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/revealKgWorkspace/WorkspaceProvenanceExplorerModal.vue"
export default component.exports